declare namespace $ {

	type $mol_view__sub_bog_smalljs_versus_pair_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['head_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['sections'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_versus_pair_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_smalljs_versus_pair_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_versus_pair_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_bog_smalljs_versus_pair_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_versus_pair_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_bog_smalljs_versus_pair_13 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['suggest_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_bog_smalljs_versus_pair_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_link__uri_bog_smalljs_versus_pair_15 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['suggest_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_versus_pair_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_bog_smalljs_versus_pair_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_versus_pair_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_smalljs_versus_pair_section__title_bog_smalljs_versus_pair_24 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['section_title'] >
		,
		ReturnType< $bog_smalljs_versus_pair_section['title'] >
	>
	type $bog_smalljs_versus_pair_section__score_bog_smalljs_versus_pair_25 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['section_score'] >
		,
		ReturnType< $bog_smalljs_versus_pair_section['score'] >
	>
	type $bog_smalljs_versus_pair_section__note_bog_smalljs_versus_pair_26 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['section_note'] >
		,
		ReturnType< $bog_smalljs_versus_pair_section['note'] >
	>
	type $bog_smalljs_versus_pair_section__content_bog_smalljs_versus_pair_27 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['section_content'] >
		,
		ReturnType< $bog_smalljs_versus_pair_section['content'] >
	>
	type $bog_smalljs_versus_pair_names__left_name_bog_smalljs_versus_pair_28 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left_title'] >
		,
		ReturnType< $bog_smalljs_versus_pair_names['left_name'] >
	>
	type $bog_smalljs_versus_pair_names__right_name_bog_smalljs_versus_pair_29 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right_title'] >
		,
		ReturnType< $bog_smalljs_versus_pair_names['right_name'] >
	>
	type $bog_smalljs_versus_pair_metric__title_bog_smalljs_versus_pair_30 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_title'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['title'] >
	>
	type $bog_smalljs_versus_pair_metric__left_value_bog_smalljs_versus_pair_31 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_left_value'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['left_value'] >
	>
	type $bog_smalljs_versus_pair_metric__right_value_bog_smalljs_versus_pair_32 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_right_value'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['right_value'] >
	>
	type $bog_smalljs_versus_pair_metric__bar_bog_smalljs_versus_pair_33 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_bar'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['bar'] >
	>
	type $bog_smalljs_versus_pair_metric__lead_bog_smalljs_versus_pair_34 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_lead'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['lead'] >
	>
	type $bog_smalljs_versus_pair_metric__left_share_bog_smalljs_versus_pair_35 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_left_share'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['left_share'] >
	>
	type $bog_smalljs_versus_pair_metric__right_share_bog_smalljs_versus_pair_36 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_right_share'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['right_share'] >
	>
	type $bog_smalljs_versus_pair_metric__delta_bog_smalljs_versus_pair_37 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_delta'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['delta'] >
	>
	type $bog_smalljs_versus_pair_metric__human_bog_smalljs_versus_pair_38 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_human'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['human'] >
	>
	type $bog_smalljs_versus_pair_metric__method_bog_smalljs_versus_pair_39 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_method'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['method'] >
	>
	type $bog_smalljs_versus_pair_metric__sources_bog_smalljs_versus_pair_40 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['metric_sources'] >
		,
		ReturnType< $bog_smalljs_versus_pair_metric['sources'] >
	>
	type $bog_smalljs_versus_pair_source__name_bog_smalljs_versus_pair_41 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['source_name'] >
		,
		ReturnType< $bog_smalljs_versus_pair_source['name'] >
	>
	type $bog_smalljs_versus_pair_source__label_bog_smalljs_versus_pair_42 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['source_label'] >
		,
		ReturnType< $bog_smalljs_versus_pair_source['label'] >
	>
	type $bog_smalljs_versus_pair_source__uri_bog_smalljs_versus_pair_43 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['source_uri'] >
		,
		ReturnType< $bog_smalljs_versus_pair_source['uri'] >
	>
	type $bog_smalljs_versus_pair_source__date_bog_smalljs_versus_pair_44 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['source_date'] >
		,
		ReturnType< $bog_smalljs_versus_pair_source['date'] >
	>
	type $bog_smalljs_versus_pair_case__case_id_bog_smalljs_versus_pair_45 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['case_id'] >
	>
	type $bog_smalljs_versus_pair_case__title_bog_smalljs_versus_pair_46 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['title'] >
	>
	type $bog_smalljs_versus_pair_case__hint_bog_smalljs_versus_pair_47 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['hint'] >
	>
	type $bog_smalljs_versus_pair_case__left_bog_smalljs_versus_pair_48 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['left'] >
	>
	type $bog_smalljs_versus_pair_case__right_bog_smalljs_versus_pair_49 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['right'] >
	>
	type $bog_smalljs_versus_pair_case__lights_bog_smalljs_versus_pair_50 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['lights'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['lights'] >
	>
	type $bog_smalljs_versus_pair_case__missing_note_bog_smalljs_versus_pair_51 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['edge_missing_note'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['missing_note'] >
	>
	type $bog_smalljs_versus_pair_case__case_id_bog_smalljs_versus_pair_52 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['case_id'] >
	>
	type $bog_smalljs_versus_pair_case__title_bog_smalljs_versus_pair_53 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['title'] >
	>
	type $bog_smalljs_versus_pair_case__hint_bog_smalljs_versus_pair_54 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['hint'] >
	>
	type $bog_smalljs_versus_pair_case__left_bog_smalljs_versus_pair_55 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['left'] >
	>
	type $bog_smalljs_versus_pair_case__right_bog_smalljs_versus_pair_56 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['right'] >
	>
	type $bog_smalljs_versus_pair_case__lights_bog_smalljs_versus_pair_57 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['lights'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['lights'] >
	>
	type $bog_smalljs_versus_pair_case__missing_note_bog_smalljs_versus_pair_58 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['edge_missing_note'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['missing_note'] >
	>
	type $bog_smalljs_versus_pair_case__case_id_bog_smalljs_versus_pair_59 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['case_id'] >
	>
	type $bog_smalljs_versus_pair_case__title_bog_smalljs_versus_pair_60 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['title'] >
	>
	type $bog_smalljs_versus_pair_case__hint_bog_smalljs_versus_pair_61 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['hint'] >
	>
	type $bog_smalljs_versus_pair_case__left_bog_smalljs_versus_pair_62 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['left'] >
	>
	type $bog_smalljs_versus_pair_case__right_bog_smalljs_versus_pair_63 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['right'] >
	>
	type $bog_smalljs_versus_pair_case__lights_bog_smalljs_versus_pair_64 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['lights'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['lights'] >
	>
	type $bog_smalljs_versus_pair_case__missing_note_bog_smalljs_versus_pair_65 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['edge_missing_note'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['missing_note'] >
	>
	type $bog_smalljs_versus_pair_case__case_id_bog_smalljs_versus_pair_66 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['case_id'] >
	>
	type $bog_smalljs_versus_pair_case__title_bog_smalljs_versus_pair_67 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['title'] >
	>
	type $bog_smalljs_versus_pair_case__hint_bog_smalljs_versus_pair_68 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_pair_case['hint'] >
	>
	type $bog_smalljs_versus_pair_case__left_bog_smalljs_versus_pair_69 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['left'] >
	>
	type $bog_smalljs_versus_pair_case__right_bog_smalljs_versus_pair_70 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['right'] >
	>
	type $bog_smalljs_versus_pair_case__lights_bog_smalljs_versus_pair_71 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['lights'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['lights'] >
	>
	type $bog_smalljs_versus_pair_case__missing_note_bog_smalljs_versus_pair_72 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['edge_missing_note'] >
		,
		ReturnType< $bog_smalljs_versus_pair_case['missing_note'] >
	>
	type $bog_smalljs_versus_code__case_id_bog_smalljs_versus_pair_73 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_code['case_id'] >
	>
	type $bog_smalljs_versus_code__left_bog_smalljs_versus_pair_74 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_code['left'] >
	>
	type $bog_smalljs_versus_code__right_bog_smalljs_versus_pair_75 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_code['right'] >
	>
	type $bog_smalljs_versus_code__case_id_bog_smalljs_versus_pair_76 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_code['case_id'] >
	>
	type $bog_smalljs_versus_code__left_bog_smalljs_versus_pair_77 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_code['left'] >
	>
	type $bog_smalljs_versus_code__right_bog_smalljs_versus_pair_78 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_code['right'] >
	>
	type $bog_smalljs_versus_code__case_id_bog_smalljs_versus_pair_79 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_code['case_id'] >
	>
	type $bog_smalljs_versus_code__left_bog_smalljs_versus_pair_80 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_code['left'] >
	>
	type $bog_smalljs_versus_code__right_bog_smalljs_versus_pair_81 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_code['right'] >
	>
	type $bog_smalljs_versus_code__case_id_bog_smalljs_versus_pair_82 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_smalljs_versus_code['case_id'] >
	>
	type $bog_smalljs_versus_code__left_bog_smalljs_versus_pair_83 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['left'] >
		,
		ReturnType< $bog_smalljs_versus_code['left'] >
	>
	type $bog_smalljs_versus_code__right_bog_smalljs_versus_pair_84 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair['right'] >
		,
		ReturnType< $bog_smalljs_versus_code['right'] >
	>
	export class $bog_smalljs_versus_pair extends $mol_view {
		head_content( ): readonly(any)[]
		Head( ): $mol_view
		sections( ): readonly(any)[]
		Sections( ): $mol_view
		method_title_text( ): string
		Method_title( ): $mol_view
		method_body( ): string
		Method_text( ): $mol_view
		method_link_label( ): string
		Method_link_icon( ): $mol_icon_open_in_new
		Method_link( ): $mol_link
		Method( ): $mol_view
		suggest_title_text( ): string
		Suggest_title( ): $mol_view
		suggest_body( ): string
		Suggest_text( ): $mol_view
		suggest_name( next?: string ): string
		Suggest_field( ): $mol_string
		suggest_uri( ): string
		suggest_send_label( ): string
		Suggest_send_icon( ): $mol_icon_open_in_new
		Suggest_send( ): $mol_link
		Suggest_form( ): $mol_view
		Suggest( ): $mol_view
		title_text( ): string
		verdict_text( ): string
		verdict_note_text( ): string
		section_title( id: any): string
		section_score( id: any): string
		section_note( id: any): string
		section_content( id: any): readonly(any)[]
		metric_title( id: any): string
		metric_left_value( id: any): string
		metric_right_value( id: any): string
		metric_bar( id: any): boolean
		metric_lead( id: any): string
		metric_left_share( id: any): string
		metric_right_share( id: any): string
		metric_delta( id: any): string
		metric_human( id: any): string
		metric_method( id: any): string
		metric_sources( id: any): readonly(any)[]
		source_name( id: any): string
		source_label( id: any): string
		source_uri( id: any): string
		source_date( id: any): string
		edge_missing_note( ): string
		left( ): string
		right( ): string
		left_title( ): string
		right_title( ): string
		lights( ): string
		verdict_win( ): string
		verdict_draw( ): string
		verdict_none( ): string
		verdict_note_edge( ): string
		verdict_note_no_runner( ): string
		verdict_note_no_runner_both( ): string
		verdict_note_gap_one( ): string
		verdict_note_gaps( ): string
		category_edge( ): string
		category_code( ): string
		category_weight( ): string
		category_speed( ): string
		category_builtin( ): string
		category_market( ): string
		category_cost( ): string
		note_edge( ): string
		note_code( ): string
		note_weight( ): string
		note_speed( ): string
		note_builtin( ): string
		note_market( ): string
		note_cost( ): string
		score_line( ): string
		score_ahead( ): string
		score_tied( ): string
		score_empty( ): string
		edge_score_line( ): string
		edge_score_empty( ): string
		edge_score_no_runner( ): string
		edge_missing_one( ): string
		edge_missing_both( ): string
		delta_below( ): string
		delta_above( ): string
		delta_times( ): string
		delta_ahead( ): string
		delta_zero( ): string
		delta_tie( ): string
		delta_only( ): string
		delta_both( ): string
		delta_neither( ): string
		delta_partial( ): string
		value_yes( ): string
		value_no( ): string
		no_data( ): string
		sub( ): readonly(any)[]
		Title( ): $mol_view
		Verdict( ): $mol_view
		Verdict_note( ): $mol_view
		Section( id: any): $bog_smalljs_versus_pair_section
		Names( id: any): $bog_smalljs_versus_pair_names
		Metric( id: any): $bog_smalljs_versus_pair_metric
		Source( id: any): $bog_smalljs_versus_pair_source
		Case_race( ): $bog_smalljs_versus_pair_case
		Case_virtual( ): $bog_smalljs_versus_pair_case
		Case_leak( ): $bog_smalljs_versus_pair_case
		Case_crash( ): $bog_smalljs_versus_pair_case
		Code_race( ): $bog_smalljs_versus_code
		Code_virtual( ): $bog_smalljs_versus_code
		Code_leak( ): $bog_smalljs_versus_code
		Code_crash( ): $bog_smalljs_versus_code
	}
	
	type $mol_view__sub_bog_smalljs_versus_pair_case_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_pair_case extends $bog_smalljs_versus_case {
		left( ): string
		right( ): string
		missing_note( ): string
		columns_count( ): number
		attr( ): ({ 
			'bog_smalljs_versus_pair_columns': ReturnType< $bog_smalljs_versus_pair_case['columns_count'] >,
		})  & ReturnType< $bog_smalljs_versus_case['attr'] >
		Missing_note( ): $mol_view
	}
	
	type $mol_view__sub_bog_smalljs_versus_pair_section_1 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair_section['head_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__dom_name_bog_smalljs_versus_pair_section_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_section_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_section_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_section_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_section_6 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair_section['content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_pair_section extends $mol_view {
		section_content( ): readonly(any)[]
		head_content( ): readonly(any)[]
		content( ): readonly(any)[]
		title( ): string
		score( ): string
		note( ): string
		sub( ): ReturnType< $bog_smalljs_versus_pair_section['section_content'] >
		Head( ): $mol_view
		Title( ): $mol_view
		Score( ): $mol_view
		Note( ): $mol_view
		Content( ): $mol_view
	}
	
	type $mol_view__sub_bog_smalljs_versus_pair_names_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_names_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_names_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_pair_names extends $mol_view {
		Left( ): $mol_view
		Middle( ): $mol_view
		Right( ): $mol_view
		left_name( ): string
		right_name( ): string
		sub( ): readonly(any)[]
	}
	
	type $mol_view__style_bog_smalljs_versus_pair_metric_1 = $mol_type_enforce<
		({ 
			'width': ReturnType< $bog_smalljs_versus_pair_metric['left_share'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_smalljs_versus_pair_metric_2 = $mol_type_enforce<
		({ 
			'width': ReturnType< $bog_smalljs_versus_pair_metric['right_share'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_4 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair_metric['row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_metric_12 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair_metric['sources'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_pair_metric extends $mol_view {
		metric_content( ): readonly(any)[]
		row_content( ): readonly(any)[]
		Bar_left( ): $mol_view
		Bar_right( ): $mol_view
		sources( ): readonly(any)[]
		title( ): string
		left_value( ): string
		right_value( ): string
		bar( ): boolean
		lead( ): string
		left_share( ): string
		right_share( ): string
		attr( ): ({ 
			'bog_smalljs_versus_pair_lead': ReturnType< $bog_smalljs_versus_pair_metric['lead'] >,
		})  & ReturnType< $mol_view['attr'] >
		delta( ): string
		human( ): string
		method( ): string
		sub( ): ReturnType< $bog_smalljs_versus_pair_metric['metric_content'] >
		Title( ): $mol_view
		Row( ): $mol_view
		Value_left( ): $mol_view
		Value_right( ): $mol_view
		Gap( ): $mol_view
		Bar( ): $mol_view
		Delta( ): $mol_view
		Human( ): $mol_view
		Method( ): $mol_view
		Sources( ): $mol_view
	}
	
	type $mol_view__sub_bog_smalljs_versus_pair_source_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_smalljs_versus_pair_source_2 = $mol_type_enforce<
		ReturnType< $bog_smalljs_versus_pair_source['uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__target_bog_smalljs_versus_pair_source_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	type $mol_link__sub_bog_smalljs_versus_pair_source_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_source_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_smalljs_versus_pair_source_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_smalljs_versus_pair_source extends $mol_view {
		source_content( ): readonly(any)[]
		name( ): string
		label( ): string
		uri( ): string
		date( ): string
		sub( ): ReturnType< $bog_smalljs_versus_pair_source['source_content'] >
		Name( ): $mol_view
		Link( ): $mol_link
		Text( ): $mol_view
		Taken( ): $mol_view
	}
	
}

//# sourceMappingURL=pair.view.tree.d.ts.map